import { render, staticRenderFns } from "./EmojiEntity.vue?vue&type=template&id=a8e9eb62"
import script from "./EmojiEntity.vue?vue&type=script&lang=js"
export * from "./EmojiEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports